"use client"

import React, { ReactNode, useEffect, useState } from 'react'
import Paper from '@mui/material/Paper'
import SkaiciuokleComponent from '../components/SkaiciuokleComponent'
import RezultatuLenteleComponent from '../components/RezultatuLenteleComponent'
import { emptyState } from './SkaiciuoklesFunkcijos'
import { changeMetai } from './SkaiciuoklesFunkcijos'

let cachedState: ReturnType<typeof emptyState> | null = null

const loadInitialState = (initialYear?: string) => {
    const baseYear = initialYear ?? new Date().getFullYear().toString()
    const base = emptyState(baseYear)
    if (!cachedState) return base

    const merged = { ...base, ...cachedState, metai: baseYear }
    try {
        return changeMetai(baseYear, { ...merged })
    } catch (e) {
        return { ...merged, metai: baseYear }
    }
}

type Props = {
    children?: ReactNode;
    onYearChange?: (year: string) => void;
    initialYear?: string;
}

type SkaiciuokleState = ReturnType<typeof emptyState>;

const Skaiciuokle = ({ children, onYearChange, initialYear }: Props) => {
    const [duomenys, setDuomenys] = useState<SkaiciuokleState>(() => loadInitialState(initialYear))

    useEffect(() => {
        if (!initialYear) return
        setDuomenys((prev) => {
            try {
                return changeMetai(initialYear, { ...prev })
            } catch (e) {
                return { ...prev, metai: initialYear }
            }
        })
    }, [initialYear])

    useEffect(() => {
        cachedState = duomenys
    }, [duomenys])

    const handleDuomenys = (duomenys: any) => {
        onYearChange?.(duomenys.metai)
        setDuomenys(duomenys)
    }

    return (
        <>
            <Paper sx={{ p: 4 }} elevation={3}>
                <SkaiciuokleComponent duomenys={duomenys} onDuomenys={handleDuomenys}>
                    {children}
                </SkaiciuokleComponent>
            </Paper>

            <Paper elevation={3}>
                <RezultatuLenteleComponent duomenys={duomenys} />
            </Paper>
        </>
    )
}

export default Skaiciuokle